import { InjectionToken } from '@angular/core';
import { KurzantragConfig } from './KurzantragConfig.type';

export const EINREICHUNG_COMPONENT = new InjectionToken('einreichung');
export const KURZANTRAG_CONFIG = new InjectionToken<KurzantragConfig>('antrags_meta_data_for_backend');
